import { TransactionError } from '../../types/web3/web3';

// a collection of undocumented web3 errors to try and use to show good error messages
const web3UserErrors = {
  // called when metamask user denies to sign the message (clicks reject or X on the extension panel)
  metamaskUserDenied:
    'MetaMask Message Signature: User denied message signature.',
  // called when user denies transaction
  metamaskUserDeniedTransaction:
    'MetaMask - RPC Error: MetaMask Tx Signature: User denied transaction signature.',
  // called when user rejects request
  userRejectedRequest: 'User rejected the request.',
  // called when closing the walletconnect modal
  userClosedModal: 'User closed modal',
  // usually called when wallet is locked
  metamaskRpcError: 'Already processing eth_requestAccounts.',
  // called when there is not eth wallet in the brawser (i.e metamask not installed)
  noMetamask: 'Non ethereum enabled browser',
  noMetamask2: 'Unable to detect window.ethereum',
};

// checks if an error message is intantional by the user
export const didUserCancelOperation = (err: TransactionError) => {
  if (err?.code && err.code === 'ACTION_REJECTED') {
    return true;
  }
  if (err?.reason && err?.reason?.toLowerCase().includes('user')) {
    return true;
  }
  if (
    typeof err?.message === 'string' &&
    err.message?.toLowerCase().includes('user denied')
  ) {
    return true;
  }

  const possibleErrors: string[] = [
    web3UserErrors.userRejectedRequest.toLocaleLowerCase(),
    web3UserErrors.userClosedModal.toLocaleLowerCase(),
  ];
  const str = err.message ? err.message.toLowerCase() : String(err);
  return !!possibleErrors.find((e: string) => str.includes(e));
};

export const isWalletLocked = (err: Error): boolean => {
  if (!err) {
    return false;
  }
  const possibleErrors: string[] = [
    web3UserErrors.metamaskRpcError.toLocaleLowerCase(),
    web3UserErrors.noMetamask.toLocaleLowerCase(),
    web3UserErrors.noMetamask2.toLocaleLowerCase(),
  ];
  const str = err.message ? err.message.toLowerCase() : String(err);
  return !!possibleErrors.find((e: string) => str.includes(e));
};

// checks if a given error is a transaction error
export const isTransactionError = (error: Error | TransactionError) => {
  const e = error as TransactionError;
  return typeof e.transaction === 'object';
};
